<template>
  <div class="child">
    <button @click="onRemoveChildReg">삭제</button>
    <dl>
      <dt>성별</dt>
      <dd class="flex">
        <span class="radioBtn">
          <input type="radio" 
            v-bind:name="'gender' + componentId" 
            v-bind:id="'male' + componentId" 
            value="M"
            v-model="child.sex"
          />
          <label 
            v-bind:for="'male' + componentId" 
          >남</label>
        </span>
        <span class="radioBtn">
          <input type="radio" 
            v-bind:name="'gender' + componentId" 
            v-bind:id="'female' + componentId" 
            value="F"
            v-model="child.sex"
          />
          <label 
            v-bind:for="'female' + componentId" 
          >여</label>
        </span>
      </dd>
      <dt>이름</dt>
      <dd>
        <input type="text" 
          v-model="child.name"
          placeholder="이름을 입력해주세요." />
      </dd>
      <dt>생년월일</dt>
      <dd>
        <input
          type="text"
          maxlength="8"
          v-model="child.birthday"
          oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
          placeholder="8자리를 입력해주세요.(예 :19000101)"
        />
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  data() {
    return {
      componentId: "",
      child: {
        name: "",
        sex: "",
        birthday: ""
      },
    };
  },
  methods: {
    onRemoveChildReg() {
      console.log(
        "DynamicChildReg.vue <onRemoveChildReg.componentId>",
        this.componentId
      );
      this.$parent.$emit("onRemoveChildReg", this.componentId);
    },
  },
  created: function () {
    console.log(this.$vnode);
    this.componentId = this.$vnode.key;
    console.log(
      "Dynamic-component.vue <created.componentId>", this.componentId
    );
  },
  beforeUpdate: function () {},
};
</script>